import { render, staticRenderFns } from "./LastPrice.vue?vue&type=template&id=d2a961dc&"
import script from "./LastPrice.vue?vue&type=script&lang=js&"
export * from "./LastPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports